import React, { useEffect, useState } from 'react';

import {
	withGoogleMap,
	GoogleMap,
	DirectionsRenderer,
	Polyline,
	InfoWindow
} from 'react-google-maps'

import './index.css'
import DeviceInfo from '../DeviceInfo';
import Markers from '../Makers';
import swal from 'sweetalert';
import Moment from 'react-moment';
import { Marker } from 'react-google-maps'
import truck from '../../../../assets/img/truck-icon.png'

export default function RouteMap({
	coordinates,
	isRoute,
	routeHistory,
	device,
	deviceDetail,
	deviceName,
	selectedTravel,
	errorTravel,
	travel
}) {

	const [coords, setCoords] = useState([]); //setar coordenadas para os markers
	const [initialCoords, setInitialCoords] = useState([-15.7801, -47.9292]); //coordenadas de bsb
	const [directions, setDirections] = useState(null); //setar direções para traçar rota de A a B
	const [centerCoords, setCenterCoords] = useState([]); //centralizar o mapa na coordenada final
	const [origin, setOrigin] = useState({}) //ponto A
	const [destination, setDestination] = useState({}) //ponto B
	const [history, setHistory] = useState([]); //pegar informação de todas as coordenadas de determinada rota
	const [deviceInfo, setDeviceInfo] = useState([]); //informação do dispositivo
	const [zoom, setZoom] = useState(15); //focar no marker clicado
	const [error, setError] = useState(false);

	const directionsService = new window.google.maps.DirectionsService();

	useEffect(() => {
		if (routeHistory) {
			setHistory(routeHistory)
			setCenterCoords(routeHistory[routeHistory.length - 1])
			setOrigin(coordinates[0])
			setDestination(coordinates[1])
		}
	}, [routeHistory])

	useEffect(() => {
		device && MarkerDeviceCallback(device)
	}, [device])

	useEffect(() => {
		directionsService.route(
			{
				origin: coordinates[0],
				destination: coordinates[1],
				travelMode: window.google.maps.TravelMode.DRIVING
			},
			(result, status) => {
				if (status === window.google.maps.DirectionsStatus.OK) {
					setDirections(result)
					setError(false)
				} else {
					console.error(`error fetching directions ${result}`);
					setError(true)
					swal("Erro!", "Não foi possível traçar trajeto", "error");
				}
			}
		);
	}, [coordinates]);

	useEffect(() => {
		if (history.length > 0) {
			routeCoords(history)
		}
	}, [history])

	function routeCoords(data) {
		let coordsArray = [];
		data.map(markers => {
			coordsArray.push({ lat: markers.location[0], lng: markers.location[1] })
		})
		setCoords(coordsArray);
	}

	function renderPending() {
		return (
			<>
				<div className="overlay">
					<div className="alert">
						<h1>Trajeto não selecionado</h1>
					</div>
				</div>
				<Map
					data={history}
					lat={-15.7801}
					lng={-47.9292}
					containerElement={<div style={{ height: `100%`, width: "100%" }} />}
					mapElement={<div style={{ height: `100%` }} />}
				/>
			</>
		);
	}

	function renderDetails() {
		const polyline = new window.google.maps.Polyline({
			path: coords,
		});

		const kilometers = window.google.maps.geometry?.spherical?.computeLength(polyline.getPath()) / 1000;

		return (
			<div className="container-last-mark">
				<div className="Title">
					Distância percorrida : {kilometers.toLocaleString('en-US', {minimumIntegerDigits: 1, useGrouping:false})} km
        		</div>
			</div>
		)
	}

	const Map = withGoogleMap(props => {

		return (
			<>
				<GoogleMap
					defaultCenter={{ lat: props.lat, lng: props.lng }}
					defaultZoom={zoom}
				>
					{isRoute ?
						<>
							< DirectionsRenderer directions={directions}
								options={{
									polylineOptions: {
										strokeOpacity: 1,
										strokeColor: '#35A0E6',
										strokeWeight: 5,
									}
								}}
							/>
							{coords.length > 1 ? renderDetails() : null}
							{travel["last_position"] !== undefined &&
								<>
									< Marker
										position={{ lat: travel.last_position[0], lng: travel.last_position[1] }}
										icon={{
											url: truck,
											scaledSize: new window.google.maps.Size(50, 40)
										}} >
										<InfoWindow>
											<div>
												<strong>Último registro</strong>
												<div>
													<strong>Dia:</strong> <Moment format="DD/MM/YYYY">{travel.last_position_date}</Moment>
												</div>
												<div>
													<strong>Horário:</strong> <Moment format="H:mm:ss">{travel.last_position_date}</Moment>
												</div>
												<div>
													<strong>Velocidade:</strong> {travel.speed} km/h
												</div>
											</div>
										</InfoWindow>
									</ Marker>
								</>
							}

							<Polyline
								path={coords}
								geodesic={false}
								options={{
									strokeColor: "#03989E",
									strokeOpacity: 1,
									strokeWeight: 5,
								}}
							/>
						</>
						:
						<>
							<Markers callback={MarkerDeviceCallback} data={props.data} />
							<Polyline
								path={coords}
								geodesic={false}
								options={{
									strokeColor: "#03989E",
									strokeOpacity: 0.75,
									strokeWeight: 5,
								}}
							/>
						</>
					}
				</GoogleMap>
			</>
		)
	});

	const MarkerDeviceCallback = data => {
		setDeviceInfo(data)
		setCenterCoords(data)
		setZoom(19)
	}

	return (
		<div className="RouteMap">
			<div className="map-container" style={{ height: '50vh' }}>
				{!isRoute && isRoute !== null && deviceDetail &&
					<DeviceInfo data={deviceInfo} deviceName={deviceName} />
				}
				{history !== undefined && centerCoords !== undefined && selectedTravel ?
					<>
						<Map
							data={routeHistory}
							lat={routeHistory[routeHistory.length - 1]?.location[0]}
							lng={routeHistory[routeHistory.length - 1]?.location[1]}
							containerElement={<div style={{ height: `100%`, width: "100%" }} />}
							mapElement={<div style={{ height: `100%` }} />}
						/>
					</>
					:
					<>
						{!selectedTravel || errorTravel || error ?
							renderPending()
							:
							<>
								<Map
									data={routeHistory}
									lat={initialCoords[0]}
									lng={initialCoords[1]}
									containerElement={<div style={{ height: `100%`, width: "100%" }} />}
									mapElement={<div style={{ height: `100%` }} />}
								/>
							</>
						}
					</>
				}
			</div>
		</div>
	)
}